module.exports = __webpack_public_path__ + "img/heart.460d525c.svg";